<script>
import {ref} from "vue";
import {useStore} from "vuex";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import router from "@/router";

export default {
  name: "HomePage",
  components: {BottomNavigation},

  setup() {

    let store = useStore()
    let HomePage = ref(store.state.HomePage)

    function load_home() {

      FreeWorld.Heisenberg({}, 'shop/homepage', true).then((res) => {

        store.commit('set_HomePage', res.data)
        HomePage.value = res.data

      }).catch((res) => {
        Swals.Catch(res, load_home)
      })

    }
    load_home()
    function check_bid() {

      if (HomePage.value.bid){
        router.push({name:'MyAuctions'})
      }else{
        Swals.Warning('متاسفانه در حال حاضر این آپشن برای فروشگاه شما فعال نمی باشد!')
      }

    }

    function log_out() {

      Swals.Question('آیا از حساب کاربری خود خارج می شوید؟' , 'خروج از حساب').then((res)=>{
        if(res.isConfirmed){
          localStorage.clear()
          store.commit('EmptyState')
          window.location.href = '/'
        }
      })

    }

    return {

      HomePage,
      check_bid,
      log_out,

    }
  }
}
</script>

<template>

  <div id="main" class="bg-main position-relative">

    <div class="position-relative">
      <div style="height: 15rem" class="bg-color rounded-bottom-5">
        <div class="d-flex justify-content-between align-items-center w-100 h-80 px-3 py-4">
          <p class="text-white font-3 font-bold">{{ HomePage.shopname }}</p>
          <img @click="log_out" src="../assets/img/exit.png" style="width: 5rem;height: 5rem">
        </div>
      </div>

      <div style="bottom: -30px; height: 5rem" class="p-body position-absolute max_width w-100">
        <div dir="rtl" class="rounded-3 shadow-custom bg-white py-2 d-flex justify-content-around align-items-center h-100">
          <img src="../assets/img/show.png" class="icon-size-5">
          <p class="mx-1 text-dark font-bold font-6">گزارش فروش امروز</p>
          <div class="mx-1 d-flex justify-content-center align-items-center" style="flex-direction: column">
            <p class="mb-2 font-6 text-dark">تعداد سفارشات هفته</p>
            <p class="font-6 font-bold font-color-green">{{ HomePage.count }}</p>
          </div>

          <div style="width: 1px;height: 50px;background-color: #777676"></div>

          <div class="d-flex justify-content-center align-items-center px-1"
               style="flex-direction: column;">
            <p class="m-0 mb-2 font-6 text-dark" style="white-space: nowrap">مبلغ سفارشات</p>
            <div class="d-flex justify-content-center align-items-center">
              <p class="font-6 font-bold font-color-green">{{ parseInt(HomePage.price).toLocaleString() }}</p>
              <p class="font-6 font-bold font-color-green">تومان</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>
    <br>

    <div dir="rtl" class="d-flex flex-wrap p-body">

      <div class="p-1 item">
      <router-link :to="{name:'WebPage',params:{type:'ویدئو های آموزشی'}}" class="d-flex flex-column text-decoration-none justify-content-evenly h-100 flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/train.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">ویدئو های آموزشی</p>
      </router-link>
     </div>

      <div class="p-1 item">
      <router-link :to="{name:'ProductsManagement'}" class="d-flex flex-column text-decoration-none h-100 justify-content-evenly flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/manage-product.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">مدیریت محصولات</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'MyOrders'}"
          class="flex-column h-100 text-decoration-none text-black justify-content-evenly d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/manage-order.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">مدیریت سفارشات</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'WalletPage'}"
          class="flex-column text-decoration-none h-100 d-flex justify-content-evenly flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/wallets.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">کیف پول و پرداخت ها</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'ReportingPage'}"
          class="flex-column text-decoration-none justify-content-evenly h-100 d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/malli.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">گزارشات مالی</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <div @click="check_bid"
          class="flex-column text-decoration-none justify-content-evenly h-100 d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/mozayede.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">مزایده های من</p>
      </div>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'OffersPage'}"
          class="flex-column text-decoration-none h-100 d-flex justify-content-evenly flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom position-relative">
        <img src="../assets/img/sellreq.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">پیشنهاد خرید</p>

        <div v-if="HomePage.offers > 0" style="top: -10px;left: -10px" class="new_offers position-absolute">
          <div class="position-relative">
            <img style="width: 30px" src="../assets/img/icon_new_offer.svg" alt="">
            <p style="left: 50%;top: 50%;transform: translate(-50%, -50%);" class="position-absolute font-5 font-bold text-white">{{ HomePage.offers }}</p>
          </div>
        </div>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'SupportPage'}"
          class="flex-column text-decoration-none h-100 text-decoration-none justify-content-evenly d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/connectto.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">ارتباط با پشتیبانی</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'ProfileEdit'}"
          class="flex-column text-decoration-none h-100 justify-content-evenly d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/manageinfo.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">مدیریت اطلاعات</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'ProductProposal'}"
          class="flex-column text-decoration-none h-100 justify-content-evenly d-flex flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/sugg.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">پیشنهاد محصول به اپلیکیشن</p>
      </router-link>
    </div>

      <div class="p-1 item">
      <router-link :to="{name:'WebPage',params:{type:'وبلاگ'}}"
          class="flex-column text-decoration-none h-100 d-flex justify-content-evenly flex-grow-0 justify-content-center align-items-center rounded-3 bg-white p-2 shadow-custom">
        <img src="../assets/img/weblag.png" class="icon_item">
        <p class="font-bold text-dark font-6 text-center">وبلاگ</p>
      </router-link>
    </div>
    </div>

    <BottomNavigation></BottomNavigation>
  </div>


</template>

<style scoped>

.icon_item {
  width: 3.5rem;
  height: 3.5rem;
}

.item {
  flex-direction: column;
  flex-basis: 33.3%;
  min-height: 10rem;
  text-decoration: none;
  color: black;
}

.new_offers{
  animation: flash 5s ease-in-out 0s infinite alternate forwards ;
}

@keyframes flash {
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
}

</style>